import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Theme {
    custom: {
      transition: string;
      boxShadow: string;
    };
  }
  interface ThemeOptions {
    custom?: {
      transition?: string;
      boxShadow?: string;
    };
  }
}

export const theme = createTheme({
  palette: {
    primary: {
      main: '#3fa0ff',
    },
    background: {
      default: '#ffffff',
    },
    text: {
      primary: '#000000',
    },
  },
  typography: {
    fontFamily: '"Urbanist", sans-serif',
    htmlFontSize: 16,
    fontSize: 14,
    h1: {
      fontFamily: '"Montserrat", sans-serif',
      fontSize: '2.5rem',
      fontWeight: 600,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontFamily: '"Montserrat", sans-serif',
      fontSize: '2rem',
      fontWeight: 500,
      letterSpacing: '-0.01em',
    },
    h3: {
      fontFamily: '"Montserrat", sans-serif',
      fontSize: '1.75rem',
      fontWeight: 500,
      letterSpacing: '-0.01em',
    },
    h4: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 600,
      letterSpacing: '-0.01em',
    },
    h5: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 500,
      letterSpacing: '-0.01em',
    },
    h6: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 500,
      letterSpacing: '-0.01em',
    },

    body1: {
      fontSize: '1.25rem',
      '@media (max-width:600px)': {
        fontSize: '1.375rem !important',
      },
      letterSpacing: '0.01em',
    },
    body2: {
      fontSize: '1.125rem',
      '@media (max-width:600px)': {
        fontSize: '1.2375rem !important',
      },
      letterSpacing: '0.01em',
    },
    button: {
      fontSize: '1rem',
      '@media (max-width:600px)': {
        fontSize: '1.1rem !important',
      },
      fontWeight: 500,
      letterSpacing: '0.02em',
    },
  },
  custom: {
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          padding: '10px 24px',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 4px 20px rgba(63, 160, 255, 0.2)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 8px 30px rgba(63, 160, 255, 0.15)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        },
      },
    },
  },
});
